import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=2d8dfced&scoped=true"
import script from "./Logout.vue?vue&type=script&setup=true&lang=js"
export * from "./Logout.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Logout.vue?vue&type=style&index=0&id=2d8dfced&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8dfced",
  null
  
)

export default component.exports